import React  from 'react';
import { useTranslation } from 'react-i18next';
import { history } from '../../routes';

export default function NoAccess({
  title = 'Title',
  headline = 'Headline',
  button = 'Back',
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <main className="bg-gray-200 w-full h-screen text-gray-600">
      <section>
        <div className="container mx-auto px-4 h-full">
          <div className="flex flex-col items-center justify-center h-screen">
            <div className="w-full lg:w-5/12 px-4 text-center">
              <h1 className="h1 text-gray-800">{t(title)}</h1>
              <p className="txt text-gray-800">{t(headline)}</p>
              <button type="button" className="btn btn-lg btn-gray" onClick={() => history.push('/')}>
                {t(button)}
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
